import {localizedResourceForm,resourceFormCaptions} from 'src/app/shared/resource-translations/resource-label.pipe';
import { Component, OnInit, OnDestroy, ChangeDetectorRef, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { CSForm } from 'src/app/shared/models/cs-form.model';
import { CSFormService } from 'src/app/shared/services/cs-form.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { FormTransactionService } from 'src/app/shared/services/form-transaction.service';
import { AuthService } from '../account/auth.service';
import { fileUploadService } from 'src/app/shared/services/fileUpload.service';
import { FormMember } from './form-member.model';
import { User } from '../account/user.model';
import { IdentityService } from 'src/app/shared/services/identity.service';
import { LinkHandlerService } from 'src/app/shared/services/link-handler.service';
import { FormDesign, formDesign, fieldText, answerText, missingFields, normalizeChoices } from 'src/app/shared/forms/form-design';
import { FormCheckoutService, FormOrderView } from 'src/app/shared/forms/form-checkout.service';
import { resourceText } from 'src/app/shared/services/localization';
declare var $: any;
@Component({ selector: 'app-form-transaction', templateUrl: './form-transaction.component.html', styleUrls: ['./form-transaction.component.scss', '../../shared/forms/forms.scss', '../../shared/forms/form-flow-layout.scss'], standalone: false })
export class FormTransactionComponent implements OnInit, OnDestroy {
    csForm: CSForm;
    formId: number;
    User: User;
    userId = '';
    user = '';
    role = 0;
    isLoading = true;
    saving = false;
    error = '';
    formNotFound = false;
    formExpired = false;
    pictureUrl = '';
    previewItem: { name: string; imageUrl?: string } = null;
    previewImageFailed = false;
    members: FormMember[] = [];
    currentMember: FormMember;
    design: FormDesign;
    step = 0;
    quote: any;
    receiptEmail = '';
    quantities: {
        [id: string]: number;
    } = {};
    userAmount: number;
    reviewAnswers: any[] = [];
    order: FormOrderView;
    intent: any;
    private baseFields: any[] = [];
    private resourceForm:any;
    private displayLanguage="";
    private pageRenders: any[] = [];
    private fileInputs = new Map<string, File[]>();
    private filePreviews = new Map<File, { name: string; url: string }>();
    private fieldErrors: { field: string; message: string }[] = [];
    private drafts = new Map<number, {
        fields: any[];
        files: Map<string, File[]>;
        quantities: any;
        amount: number;
        email: string;
    }>();
    private uploaded = new WeakMap<File, {
        name: string;
        url: string;
    }>();
    fieldText = fieldText;
    answerText = answerText;
    constructor(private route: ActivatedRoute, private formService: CSFormService, private formTransactionService: FormTransactionService, public globalService: GlobalService, private location: Location, private authService: AuthService, private uploads: fileUploadService, private identity: IdentityService, private router: Router, private links: LinkHandlerService, private checkout: FormCheckoutService, private cdr: ChangeDetectorRef, private element: ElementRef) { }
    ngDoCheck() {
        if(this.isLoading||!this.resourceForm||this.displayLanguage===this.globalService.locale)return;
        this.displayLanguage=this.globalService.locale;
        this.csForm=localizedResourceForm(this.resourceForm,this.displayLanguage);this.globalService.screenHeader=this.csForm.name;
        this.baseFields=JSON.parse(this.csForm.formData||'[]').filter(f=>!f.access||f.role?.includes(String(this.role)));
        this.design=formDesign(this.csForm.designJson,JSON.parse(this.csForm.formData||'[]'));
        if(this.pageRenders.length){const step=this.step,quote=this.quote;this.changingMember(Math.max(0,this.members.indexOf(this.currentMember)));this.step=step;this.quote=quote;this.reviewAnswers=this.answers();this.showPage();}
    }
    openItemPhoto(item: { name: string; imageUrl?: string }, dialog: HTMLDialogElement) {
        if (!item.imageUrl) return;
        this.previewItem = item;
        this.previewImageFailed = false;
        dialog.showModal();
    }
    async ngOnInit() {
        this.isLoading = true;
        this.error = '';
        try {
            this.User = await this.authService.autoLogin(0);
            this.userId = this.User?.id || '';
            this.user = this.globalService.currentUser || '';
            this.role = this.identity.hasFormAdmin() ? 1 : this.identity.hasFormEditor() ? 2 : this.identity.hasFormsView() ? 3 : 0;
            this.formId = Number(this.route.snapshot.params.formId);
            this.resourceForm=await this.formService.getForm(this.formId);
            this.displayLanguage=this.globalService.locale;
            this.csForm = localizedResourceForm(this.resourceForm,this.displayLanguage);
            if (!this.csForm?.id || this.csForm.deleted) {
                this.formNotFound = true;
                return;
            }
            if (this.csForm.formExpires && new Date(this.csForm.validThru) < new Date()) {
                this.formExpired = true;
                return;
            }
            if (this.csForm.requireLogin && this.csForm.action !== 6 && !this.User) {
                this.router.navigate([this.globalService.subdomain + '/login']);
                return;
            }
            this.globalService.title.push(this.globalService.screenHeader);
            this.globalService.screenHeader = this.csForm.name;
            this.baseFields = JSON.parse(this.csForm.formData || '[]').filter(f => !f.access || f.role?.includes(String(this.role)));
            this.design = formDesign(this.csForm.designJson, JSON.parse(this.csForm.formData || '[]'));
            this.pictureUrl = this.csForm.pictureUrl || '';
            if (this.User && this.csForm.memberSelection && this.csForm.action !== 6)
                this.members = await this.formService.getFormMembers(this.userId, this.formId) || [];
            if (this.csForm.memberSelection && this.csForm.requireLogin && this.csForm.action !== 6 && !this.members.length)
                throw Error('FORM_NO_MEMBERS');
            this.userAmount = this.design.payment.suggested ?? this.design.payment.minimum;
            this.receiptEmail = this.User?.['email'] || '';
            this.intent = this.checkout.intent(this.globalService.subdomain, this.formId);
            if (this.intent.orderId) {
                this.router.navigate([this.globalService.subdomain + '/form-order/' + this.intent.orderId]);
                return;
            }
            this.changingMember(0);
        }
        catch (e) {
            this.error = resourceText(e?.message === 'FORM_NO_MEMBERS' ? 'FORM_NO_MEMBERS' : 'FORM_LOAD_FAILED');
        }
        finally {
            this.isLoading = false;
            this.cdr.markForCheck();
        }
    }
    get questionCount() { return this.design?.pages.length || 0; }
    get paymentStep() { return this.questionCount; }
    get reviewStep() { return this.questionCount + (this.csForm?.paymentsEnabled ? 1 : 0); }
    get stepCount() { return this.reviewStep + 1; }
    get total() { if (!this.csForm?.paymentsEnabled)
        return 0; const p = this.design.payment; return p.mode === 'fixed' ? this.csForm.paymentAmount || 0 : p.mode === 'custom' ? Number(this.userAmount) || 0 : p.items.reduce((n, item) => n + (this.quantities[item.id] || 0) * item.unitPrice, 0); }
    private answers() { return this.pageRenders.reduce((all, renderer) => all.concat(renderer.userData || []), []).map(f => ({ ...f, ...(f.type === 'file' ? { data: (this.fileInputs.get(f.name) || []).map(file => this.uploaded.get(file) || { name: file.name, url: '' }) } : {}) })); }
    changingMember(index: number) {
        this.clearFieldErrors();
        this.error = '';
        if (this.pageRenders.length)
            this.drafts.set(this.currentMember?.id || 0, { fields: this.answers(), files: new Map(this.fileInputs), quantities: { ...this.quantities }, amount: this.userAmount, email: this.receiptEmail });
        this.currentMember = this.members[index];
        const saved = this.drafts.get(this.currentMember?.id || 0);
        let fields = resourceFormCaptions(normalizeChoices(JSON.parse(JSON.stringify(saved?.fields || this.baseFields))),normalizeChoices(this.baseFields));
        // Browsers forbid restoring a file input from a fake path string. Restore
        // actual File objects below instead, while retaining their draft metadata.
        fields.filter(field => field.type === 'file').forEach(field => { delete field.userData; delete field.value; });
        this.fileInputs = new Map(saved?.files || []);
        this.quantities = { ...this.design.payment.items.reduce((values, item) => { values[item.id] = 0; return values; }, {} as { [id: string]: number }), ...saved?.quantities };
        this.userAmount = saved?.amount ?? this.design.payment.suggested ?? this.design.payment.minimum;
        this.receiptEmail = saved?.email ?? this.currentMember?.emailAddress ?? this.User?.['email'] ?? '';
        if (!saved) {
            const m = this.currentMember;
            const basic = { bi_first_name: m?.firstName, bi_last_name: m?.lastName, bi_full_name: m ? m.firstName + ' ' + m.lastName : '', bi_email: m?.emailAddress, bi_street: m?.street, bi_city: m?.city, bi_state: m?.state, bi_zip: m?.zip, bi_cell_phone: m?.phoneNumber, bi_marital: m?.maritalStatus, bi_gender: m?.gender == null ? '' : m.gender ? '1' : '0', bi_dob: m?.dateOfBirth ? String(m.dateOfBirth).slice(0, 10) : '' };
            if (m)
                for (const f of fields)
                    if (Object.prototype.hasOwnProperty.call(basic, f.name)) {
                        f.userData = [String(basic[f.name] ?? '')];
                        f.values?.forEach(v => v.selected = String(v.value) === f.userData[0]);
                    }
        }
        const root: HTMLElement = this.element.nativeElement.querySelector('.fb-render');
        root.replaceChildren();
        this.pageRenders = [];
        this.design.pages.forEach((page, index) => {
            const host = document.createElement('div');
            host.dataset.formPage = String(index);
            root.appendChild(host);
            const pageFields = fields.filter(f => page.fields.includes(f.name) || index === 0 && !f.name);
            const renderer = $(host).formRender({ dataType: 'json', formData: pageFields, roles: { 1: 'Form Admin', 2: 'Form Editor', 3: 'Form Viewer' } });
            this.pageRenders.push(renderer);
            host.querySelectorAll<HTMLInputElement>('input[type=file]').forEach(input => {
                const name = input.name.replace(/\[\]$/, '');
                const savedFiles = this.fileInputs.get(name) || [];
                if (savedFiles.length) {
                    // Restore the native file list when switching between members' drafts.
                    try { const transfer = new DataTransfer(); savedFiles.forEach(file => transfer.items.add(file)); input.files = transfer.files; } catch { }
                }
                this.renderFilePreviews(input);
                input.addEventListener('change', () => {
                    this.fileInputs.set(name, Array.from(input.files || []));
                    this.renderFilePreviews(input);
                });
            });
            const clear = (event: Event) => {
                const name = (event.target as HTMLInputElement).name?.replace(/\[\]$/, '');
                if (this.fieldErrors.some(error => error.field === name)) {
                    this.fieldErrors = this.fieldErrors.filter(error => error.field !== name);
                    this.renderFieldErrors(false);
                    this.cdr.markForCheck();
                }
            };
            host.addEventListener('input', clear);
            host.addEventListener('change', clear);
        });
        this.step = 0;
        this.quote = null;
        this.showPage();
    }
    private showPage(scroll = false) {
        this.element.nativeElement.querySelectorAll('[data-form-page]').forEach((el: HTMLElement) => el.hidden = Number(el.dataset.formPage) !== this.step);
        if (scroll) {
            this.cdr.detectChanges();
            this.element.nativeElement.querySelector('.form-progress')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
    }
    previewsFor(field: any) {
        return (this.fileInputs.get(field.name) || []).filter(file => /^image\//i.test(file.type) || /\.(png|jpe?g|gif|webp|avif|bmp)$/i.test(file.name)).map(file => {
            if (!this.filePreviews.has(file)) this.filePreviews.set(file, { name: file.name, url: URL.createObjectURL(file) });
            return this.filePreviews.get(file);
        });
    }
    private renderFilePreviews(input: HTMLInputElement) {
        input.parentElement.querySelectorAll('.form-attachment-previews').forEach(node => node.remove());
        const name = input.name.replace(/\[\]$/, '');
        const files = this.fileInputs.get(name) || [];
        if (!files.length) return;
        const container = document.createElement('div');
        container.className = 'form-attachment-previews';
        for (const preview of this.previewsFor({ name })) {
            const figure = document.createElement('figure');
            const image = document.createElement('img');
            image.src = preview.url;
            image.alt = preview.name;
            const caption = document.createElement('figcaption');
            caption.textContent = preview.name;
            image.addEventListener('error', () => { image.hidden = true; caption.textContent = preview.name + ' â€” ' + resourceText('FORM_IMAGE_UNAVAILABLE'); }, { once: true });
            figure.append(image, caption);
            container.appendChild(figure);
        }
        const clear = document.createElement('button');
        clear.type = 'button';
        clear.textContent = resourceText('CLEAR');
        clear.addEventListener('click', () => {
            input.value = '';
            this.fileInputs.delete(name);
            this.renderFilePreviews(input);
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        container.appendChild(clear);
        input.insertAdjacentElement('afterend', container);
    }
    ngOnDestroy() {
        this.filePreviews.forEach(preview => URL.revokeObjectURL(preview.url));
        this.filePreviews.clear();
    }
    private validPage(index: number) {
        const fields = this.pageRenders[index]?.userData || [];
        const missing = missingFields(fields, this.fileInputs);
        this.fieldErrors = missing.map(field => ({ field: field.name, message: resourceText('FORM_FIELD_REQUIRED') }));
        const host = this.element.nativeElement.querySelector(`[data-form-page="${index}"]`);
        host?.querySelectorAll('input:not([type=file]),select,textarea').forEach((el: HTMLInputElement) => {
            const name = el.name.replace(/\[\]$/, '');
            if (!el.checkValidity() && !this.fieldErrors.some(error => error.field === name))
                this.fieldErrors.push({ field: name, message: el.validationMessage || resourceText('FORM_FIELD_INVALID') });
        });
        this.renderFieldErrors();
        return !this.fieldErrors.length;
    }
    private clearFieldErrors() {
        this.fieldErrors = [];
        this.element.nativeElement.querySelectorAll('.form-answer-error').forEach((node: HTMLElement) => node.remove());
        this.element.nativeElement.querySelectorAll('[data-form-invalid]').forEach((node: HTMLElement) => {
            const id = node.dataset.formInvalid;
            const describedBy = (node.getAttribute('aria-describedby') || '').split(' ').filter(value => value && value !== id).join(' ');
            if (describedBy) node.setAttribute('aria-describedby', describedBy); else node.removeAttribute('aria-describedby');
            node.removeAttribute('aria-invalid');
            delete node.dataset.formInvalid;
        });
    }
    private renderFieldErrors(focus = true) {
        const errors = this.fieldErrors;
        this.clearFieldErrors();
        this.fieldErrors = errors;
        const messages: string[] = [];
        let first: HTMLElement;
        for (const [index, issue] of errors.entries()) {
            const definition = this.baseFields.find(field => field.name === issue.field);
            if (!definition) continue;
            const page = this.design.pages.findIndex(page => page.fields.includes(issue.field));
            const host = this.element.nativeElement.querySelector(`[data-form-page="${page}"]`);
            const controls = Array.from(host?.querySelectorAll('input,select,textarea') || []).filter((el: HTMLInputElement) => el.name.replace(/\[\]$/, '') === issue.field) as HTMLElement[];
            const label = fieldText(definition.label || definition.name).trim();
            messages.push(label + ': ' + issue.message);
            if (!controls.length) continue;
            const message = document.createElement('p');
            message.id = 'form-answer-error-' + index;
            message.className = 'form-answer-error';
            message.textContent = issue.message;
            const group = controls[0].closest('.form-group') || controls[0].parentElement;
            group.appendChild(message);
            controls.forEach(control => {
                control.setAttribute('aria-invalid', 'true');
                control.dataset.formInvalid = message.id;
                control.setAttribute('aria-describedby', [control.getAttribute('aria-describedby'), message.id].filter(Boolean).join(' '));
            });
            if (!first) {
                first = controls[0];
                if (focus && page >= 0) { this.step = page; this.showPage(); }
            }
        }
        this.error = messages.length ? resourceText('FORM_FIX_FIELDS') + ' ' + messages.join(' ') : '';
        if (focus && first) {
            // Settle the summary height before positioning the first invalid answer.
            this.cdr.detectChanges();
            first.scrollIntoView({ block: 'center', behavior: 'smooth' });
            first.focus({ preventScroll: true });
        }
    }
    private checkoutError(e: any, fallback: string) {
        const issues = e?.error?.fieldErrors;
        if (Array.isArray(issues)) {
            const allowed = ['FORM_FIELD_REQUIRED', 'FORM_FIELD_CHOICE', 'FORM_FIELD_INVALID'];
            this.fieldErrors = issues.filter(issue => allowed.includes(issue.code) && this.baseFields.some(field => field.name === issue.field))
                .map(issue => ({ field: issue.field, message: resourceText(issue.code) }));
            if (this.fieldErrors.length) { this.renderFieldErrors(); return; }
        }
        const code = e?.error?.code;
        const message = typeof code === 'string' && code.startsWith('FORM_') ? resourceText(code) : '';
        this.error = e?.status === 401 || e?.status === 403 ? resourceText('FORM_ACCESS_REQUIRED')
            : message && message !== code ? message : resourceText(fallback);
    }
    async next() {
        if (this.saving)
            return;
        this.error = '';
        this.clearFieldErrors();
        if (this.step < this.questionCount && !this.validPage(this.step))
            return;
        if (this.step + 1 === this.reviewStep) {
            await this.review();
            return;
        }
        this.step++;
        this.showPage(true);
    }
    back() { if (this.saving)
        return; this.error = ''; this.step = Math.max(0, this.step - 1); this.showPage(true); }
    editPage(index: number) { if (this.saving || this.order)
        return; this.step = index; this.showPage(true); }
    request() { return { formId: this.formId, memberId: this.currentMember?.id || 0, formData: JSON.stringify(this.answers()), quantities: this.quantities, userAmount: this.userAmount, receiptEmail: this.receiptEmail }; }
    async review() { this.saving = true; try {
        this.quote = await this.checkout.quote(this.request());
        this.reviewAnswers = this.answers();
        this.step = this.reviewStep;
        this.showPage(true);
    }
    catch (e) {
        this.checkoutError(e, 'FORM_REVIEW_FAILED');
    }
    finally {
        this.saving = false;
        this.cdr.markForCheck();
    } }
    itemCaption(line:any) { return this.design?.payment.items.find(item=>item.id===line.itemId)?.name || line.name; }
    async submit() {
        if (this.saving || this.order || this.step !== this.reviewStep || !this.quote)
            return;
        this.saving = true;
        this.error = '';
        try {
            const root: HTMLElement = this.element.nativeElement.querySelector('.fb-render');
            root.querySelectorAll<HTMLInputElement>('input[type=file]').forEach(input => { if (input.files?.length)
                this.fileInputs.set(input.name.replace(/\[\]$/, ''), Array.from(input.files)); });
            for (const files of this.fileInputs.values())
                for (const file of files)
                    if (!this.uploaded.has(file)) {
                        const url = await this.uploads.uploadFile(file, file.name, 'attachments');
                        if (!url)
                            throw Error('FORM_UPLOAD_FAILED');
                        this.uploaded.set(file, { name: file.name, url });
                    }
            this.order = await this.checkout.submit({ ...this.request(), quoteHash: this.quote.hash, ...this.intent });
            this.checkout.remember(this.globalService.subdomain, this.formId, this.intent, this.order);
            if (this.order.status === 'submitted' && this.csForm.submitUrl?.trim())
                this.links.open(this.csForm.submitUrl.trim());
        }
        catch (e) {
            const code = e?.error?.code || 'FORM_SUBMIT_FAILED';
            this.checkoutError(e, 'FORM_SUBMIT_FAILED');
            if (code === 'FORM_CHANGED_REVIEW')
                this.quote = null;
        }
        finally {
            this.saving = false;
            this.cdr.markForCheck();
        }
    }
    quantity(id: string, delta: number, max: number) { this.quantities[id] = Math.min(max, Math.max(0, Math.trunc(Number(this.quantities[id]) || 0) + delta)); }
    filesFor(field: any) { return this.fileInputs.get(field.name)?.map(f => f.name).join(', ') || answerText(field); }
}
